module.exports = __webpack_public_path__ + "static/media/DSC_0087.8a8081fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0087.jpg
// module id = 628
// module chunks = 0